// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f104505c","239":"e92ce48c","455":"6a4d361d"}[chunkId] + ".chunk.js";
};